<template>
    <apexo-modal
        name="order"
        size="sm"
        :title="$t('orders.modal.title')"
        ref="modal"
        @open="onOpen"
        @opened="onOpened"
    >
        <section class="space-y-4">
            <table class="min-w-full table-fixed">
                <thead>
                    <tr class="text-left text-xs leading-4 text-gray-500 uppercase tracking-wider">
                        <th class="w-3/4 px-6 py-3 font-medium">
                            {{ $t('orders.modal.licenseType') }}
                        </th>
                        <th class="w-1/4 px-6 py-3 font-medium">
                            {{ $t('orders.modal.quantity') }}
                        </th>
                    </tr>
                </thead>

                <tbody class="bg-white">
                    <tr
                        class="text-sm leading-5"
                        :key="orderItem.id"
                        v-for="(orderItem, index) in orderItems"
                    >
                        <td class="px-6 py-4 whitespace-no-wrap border-t border-gray-200 font-medium text-gray-900">
                            {{ orderItem.label }}
                        </td>

                        <td class="px-6 py-4 whitespace-no-wrap border-t border-gray-200 text-gray-500">
                            <apexo-input
                                classes="w-full"
                                placeholder="0"
                                :ref="`quantity_${index}`"
                                v-model="orderItem.quantity"
                            />
                        </td>
                    </tr>
                </tbody>
            </table>

            <div class="bg-gray-100 border border-gray-200 p-4 text-sm text-gray-600 rounded-sm">
                {{ $t('orders.modal.instructions') }}
            </div>
        </section>

        <template #footer>
            <apexo-button
                :disabled="$wait.is('creating.order')"
                :primary="false"
                @click="close"
            >
                {{ $t('global.general.cancel') }}
            </apexo-button>

            <apexo-button
                :disabled="!isValid || $wait.is('creating.order')"
                :loading="$wait.is('creating.order')"
                @click="createOrder"
            >
                {{ $t('orders.modal.send') }}
            </apexo-button>
        </template>
    </apexo-modal>
</template>

<script>
    import { mapMutations, mapState } from 'vuex';
    import ApexoButton from '@/components/Elements/ApexoButton.vue';
    import ApexoModal from '@/components/Elements/ApexoModal';
    import ApexoInput from '@/components/Elements/ApexoInput';

    export default {
        components: {
            ApexoButton,
            ApexoModal,
            ApexoInput,
        },

        data() {
            return {
                orderItems: [],
            };
        },

        computed: {
            ...mapState([
                'authUser',
            ]),

            isValid() {
                return this.orderItems.some(item => item.quantity > 0);
            },
        },

        methods: {
            ...mapMutations([
                'addOrder',
            ]),

            async createOrder() {
                this.$wait.start('creating.order');

                const items = this.orderItems
                    .filter(orderItem => orderItem.quantity > 0)
                    .map(orderItem => {
                        return {
                            license_type_id: orderItem.id,
                            quantity: orderItem.quantity,
                        };
                    });

                try {
                    const response = await this.$axios.post('orders', {
                        client_id: this.authUser.client.id,
                        items,
                    });

                    this.addOrder(response.data.data);

                    this.close();
                } catch (error) {
                    console.log(error);
                    // Show error
                } finally {
                    this.$wait.end('creating.order');
                }
            },

            onOpen() {
                this.orderItems = this.authUser.client.license_types.map(licenseType => {
                    const name = licenseType.localized_name[this.$i18n.locale];
                    const platform = this.$t(`global.platform.${licenseType.platform}`);

                    return {
                        id: licenseType.id,
                        label: `${name} (${platform})`,
                        quantity: null,
                    };
                });
            },

            onOpened() {
                this.$refs.quantity_0[0].focus();
            },

            close() {
                this.$refs.modal.close();
            },
        },
    };
</script>
